exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-linksheet-privacy-policy-tsx": () => import("./../../../src/pages/linksheet/privacy-policy.tsx" /* webpackChunkName: "component---src-pages-linksheet-privacy-policy-tsx" */),
  "component---src-pages-magic-tsx": () => import("./../../../src/pages/magic.tsx" /* webpackChunkName: "component---src-pages-magic-tsx" */),
  "component---src-pages-secret-tsx": () => import("./../../../src/pages/secret.tsx" /* webpackChunkName: "component---src-pages-secret-tsx" */)
}

